import { EntityForm, Notice } from '@lbcamden/lib-react';
import { FunctionComponent } from 'react';

import { useUserStore } from '~/client/hooks/storeHooks';
import { PcfraPerson, PcfraStatus } from '~/common/types/people';

import { notifyReferrerMessage } from '../config';
import { CurrentResidentsDialog, DialogContent } from '../CurrentResidents.styled';
import { useHandlePcfraActivity } from '../useHandlePcfraActivity';
import { formConfig, formSchema, RecordAssessmentFormValues } from './config';

type Props = {
  open?: boolean;
  person?: PcfraPerson;
  onClose(): void;
};

const title = 'Revoke PCFRA';

export const RevokePcfraDialog: FunctionComponent<Props> = ({ open, person, onClose }) => {
  const userStore = useUserStore();
  const handlePcfraActivity = useHandlePcfraActivity();

  const onSave = ({ replacementNeeded, note, pcfraReviewDate }: RecordAssessmentFormValues) => {
    if (!person) {
      return;
    }
    const { propertyId, personId } = person;

    const newPcfraStatus =
      replacementNeeded === 'Yes' ? PcfraStatus.Necessary : PcfraStatus.Unnecessary;

    userStore?.store.transaction(() => {
      handlePcfraActivity({
        propertyId,
        personId,
        newPcfraStatus,
        note,
        pcfraReviewDate: pcfraReviewDate || null,
        shouldNotifyReferrer: true,
      });
      userStore.handleAndDispatchMessage('revokePcfra', personId, { propertyId, personId });
    });

    onClose();
  };

  return (
    <CurrentResidentsDialog open={open} title={title} accessibleInfo={{ title }} onClose={onClose}>
      <DialogContent>
        <Notice
          type="warning"
          title="Warning"
          message="This resident's current PCFRA will be removed."
        />
        <EntityForm<RecordAssessmentFormValues>
          inDialog
          schema={formSchema}
          config={formConfig}
          initialValue={{ pcfraReviewDate: person?.pcfraReviewDate }}
          message={notifyReferrerMessage}
          onCancel={onClose}
          onSave={onSave}
        />
      </DialogContent>
    </CurrentResidentsDialog>
  );
};
